<template>
  <b-overlay :show="show">
    <div class="my-register-page" style="font-size: 14px">
      <div class="my-container">
       
        <!-- Inspection info -->
        <div class="cardStyleEdit mb-3 p-3">
          <b-row>
            <b-col cols="12" md="6" class="mb-3">
              <div class="ml-label">{{ $t("docNumber") }}</div>
              <div class="ml-value">{{ Inspection.docNumber || "—" }}</div>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
              <div class="ml-label">{{ $t("docDate") }}</div>
              <div class="ml-value">{{ Inspection.docDate || "—" }}</div>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
              <div class="ml-label">{{ $t("contractor") }}</div>
              <div class="ml-value">{{ Inspection.contractor || "—" }}</div>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
              <div class="ml-label">{{ $t("organization") }}</div>
              <div class="ml-value">
                {{ Inspection.organizationName || Inspection.organization || "—" }}
              </div>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
              <div class="ml-label">{{ $t("employee") }}</div>
              <div class="ml-value">
                {{ Inspection.personName || Inspection.person || "—" }}
              </div>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
              <div class="ml-label">{{ $t("type") || "Turi" }}</div>
              <div class="ml-value">{{ Inspection.applicationType || "—" }}</div>
            </b-col>
            <b-col cols="12" class="mb-1">
              <div class="ml-label">{{ $t("visitPurpose") }}</div>
              <div class="ml-value">{{ Inspection.visitPurpose || "—" }}</div>
            </b-col>
          </b-row>
        </div>

        <!-- Files -->
        <div class="cardStyleEdit mb-3 p-3">
          <h5 class="styleText mb-2">{{ $t("files") }}</h5>
          <b-table-simple
            v-if="Inspection.files && Inspection.files.length"
            bordered
            responsive
            class="mb-0"
          >
            <b-thead>
              <b-tr variant="primary">
                <b-th style="width: 60px">№</b-th>
                <b-th>{{ $t("fileName") || "Fayl nomi" }}</b-th>
                <b-th class="text-center" style="width: 120px">
                  {{ $t("download") || "Yuklab olish" }}
                </b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr
                v-for="(file, fIndex) in Inspection.files"
                :key="file.id || fIndex"
              >
                <b-td>{{ fIndex + 1 }}</b-td>
                <b-td>
                  <b-link @click="DownloadFile(file)">
                    {{ file.name || file.fileName || file.id }}
                  </b-link>
                </b-td>
                <b-td class="text-center">
                  <b-link @click="DownloadFile(file)">
                    <b-icon font-scale="1.2" icon="download"></b-icon>
                  </b-link>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <div v-else class="text-muted">
            {{ $t("noData") }}
          </div>
        </div>

        <!-- Rating block -->
        <section class="rt-card mb-3">
          <div class="rt-card-head">
            <h2>{{ $t("RatingStep2") || "Baholash" }}</h2>
            <span class="rt-hint">
              {{ $t("RatingStep2Hint") || "5 ballik tizim" }} ·
              {{ $t("CommentOptional") || "Izoh majburiy emas" }}
            </span>
          </div>
          <div class="rt-card-body">
            <div v-if="rating.alreadyRated" class="rt-already">
              <i class="fas fa-check-circle"></i>
              {{ $t("RatingAlreadySubmitted") || "Baholash yuborilgan" }}
            </div>

            <!-- Inspection process -->
            <div class="rt-rate-block">
              <div class="rt-who">
                <div class="rt-who-icon">
                  <i class="fas fa-clipboard-check"></i>
                </div>
                <div>
                  <!-- <div class="rt-who-lbl">
                    {{ $t("InspectionProcess") || "Tekshiruv jarayoni" }}
                  </div> -->
                  <div class="rt-who-nm">{{ Inspection.docNumber || "—" }}</div>
                </div>
              </div>
              <div class="rt-stars">
                <button
                  v-for="n in 5"
                  :key="'p' + n"
                  type="button"
                  class="rt-star"
                  :class="{ filled: n <= rating.inspectionRating }"
                  :disabled="rating.alreadyRated || rating.submitting"
                  @click="rating.alreadyRated || (rating.inspectionRating = n)"
                >
                  <i class="fas fa-star"></i>
                </button>
                <strong class="rt-stars-val">
                  {{ rating.inspectionRating }} / 5
                </strong>
              </div>
              <textarea
                v-model="rating.inspectionComment"
                class="rt-comment"
                maxlength="500"
                :disabled="rating.alreadyRated || rating.submitting"
                :placeholder="
                  $t('InspectionCommentPh') ||
                  'Tekshiruv jarayoni haqida izoh (ixtiyoriy)'
                "
              ></textarea>
            </div>
          </div>

          <div
            v-if="rating.error"
            class="rt-error"
            style="margin: 0 22px 12px"
          >
            <i class="fas fa-exclamation-circle"></i> {{ rating.error }}
          </div>

          <div v-if="!rating.alreadyRated" class="rt-actions">
            <button
              type="button"
              class="rt-btn primary"
              :disabled="!canSubmitRating || rating.submitting"
              @click="submitRating"
            >
              <i v-if="rating.submitting" class="fas fa-spinner fa-spin"></i>
              <template v-else>
                {{ $t("Submit") || "Yuborish" }}
                <i class="fas fa-arrow-right"></i>
              </template>
            </button>
          </div>
        </section>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BIcon,
  BLink,
  BOverlay,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
} from "bootstrap-vue";
import InspectionService from "@/services/inspection.service";
import RequestRatingService from "@/services/requestrating.service";

export default {
  name: "MuloqotListView",
  components: {
    BRow,
    BCol,
    BIcon,
    BLink,
    BOverlay,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {
      show: false,
      Inspection: {},
      rating: {
        submitting: false,
        alreadyRated: false,
        error: "",
        inspectionRating: 0,
        inspectionComment: "",
      },
    };
  },
  computed: {
    canSubmitRating() {
      return this.rating.inspectionRating >= 1;
    },
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      this.show = true;
      InspectionService.Get(this.$route.params.id)
        .then((res) => {
          this.Inspection = res.data || {};
          this.show = false;
          if (this.Inspection.ratings && this.Inspection.ratings.length) {
            this.applyRating(this.Inspection.ratings);
          } else if (this.Inspection.docNumber) {
            this.loadRating(this.Inspection.docNumber);
          }
        })
        .catch((error) => {
          this.show = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    loadRating(docNumber) {
      RequestRatingService.GetList({
        search: docNumber,
        sortBy: "",
        orderType: "",
        page: 1,
        pageSize: 20,
      })
        .then((r) => {
          const rows = (r && r.data && (r.data.rows || r.data.items)) || [];
          const own = rows.filter((x) => x.docNumber === docNumber);
          this.applyRating(own);
        })
        .catch(() => {
          /* ignore — assume not rated */
        });
    },
    applyRating(rows) {
      if (!rows || !rows.length) return;
      this.rating.alreadyRated = true;
      const proc = rows[0];
      this.rating.inspectionRating = proc.rating || 0;
      this.rating.inspectionComment = proc.text || "";
    },
    submitRating() {
      if (!this.canSubmitRating || this.rating.submitting) return;
      this.rating.submitting = true;
      this.rating.error = "";
      const payload = {
        docNumber: this.Inspection.docNumber,
        ratingTypeId: 3,
        rating: this.rating.inspectionRating,
        isRequest: true,
        text: this.rating.inspectionComment || "",
      };
      RequestRatingService.Create(payload)
        .then(() => {
          this.rating.alreadyRated = true;
          this.makeToast(
            this.$t("RatingSubmitted") || "Muvaffaqiyatli yuborildi",
            "success"
          );
        })
        .catch((err) => {
          this.rating.error = this.extractRatingError(err);
        })
        .finally(() => {
          this.rating.submitting = false;
        });
    },
    extractRatingError(err) {
      const fallback =
        this.$t("RatingSubmitError") || "Baholashni yuborishda xatolik";
      const data = err && err.response && err.response.data;
      if (!data) return fallback;
      if (typeof data === "string" && data.trim()) return data;
      if (data.errors && typeof data.errors === "object") {
        const msgs = [];
        Object.values(data.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else if (typeof v === "string") msgs.push(v);
        });
        if (msgs.length) return Array.from(new Set(msgs)).join("; ");
      }
      if (data.message) return data.message;
      if (data.title) return data.title;
      return fallback;
    },
    DownloadFile(file) {
      if (!file || !file.id) return;
      InspectionService.DownloadFile(file.id)
        .then((res) => {
          const contentType =
            (res.headers && res.headers["content-type"]) ||
            "application/octet-stream";
          const blob =
            res.data instanceof Blob
              ? res.data
              : new Blob([res.data], { type: contentType });

          let filename = file.name || file.fileName || "";
          const disposition =
            res.headers && res.headers["content-disposition"];
          if (disposition) {
            const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
            const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
            if (utf8Match) {
              filename = decodeURIComponent(utf8Match[1]);
            } else if (asciiMatch) {
              filename = asciiMatch[1];
            }
          }
          if (!filename) filename = file.id;

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    back() {
      this.$router.push({ name: "muloqotlist" });
    },
    makeToast(message, type) {
      let a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400 && message.errors) {
        const errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.ml-title {
  font-size: 22px;
  margin: 0;
}

.cardStyleEdit {
  background-color: #eaf2ff;
  border-radius: 10px;
}
.styleText {
  font-weight: 800;
}

.ml-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7388;
  margin-bottom: 3px;
}
.ml-value {
  font-size: 15px;
  font-weight: 600;
  color: #1c2238;
  word-break: break-word;
}

.my-bg-light {
  background: #fff;
  border: 1.5px solid #d1d5db;
  color: #374151;
}

/* Rating block */
.rt-card {
  background: #fff;
  border: 1px solid #e3e6ee;
  border-radius: 14px;
  overflow: hidden;
}
.rt-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eef0f5;
  gap: 12px;
  flex-wrap: wrap;
}
.rt-card-head h2 {
  font-size: 16px;
  font-weight: 800;
  margin: 0;
  color: #1c2238;
}
.rt-hint {
  font-size: 12px;
  color: #6b7388;
}
.rt-card-body {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.rt-already {
  background: #d1fae5;
  color: #065f46;
  padding: 10px 14px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-rate-block {
  padding: 14px;
  background: #f8f9fc;
  border-radius: 12px;
  border: 1px solid #eef0f5;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.rt-who {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rt-who-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #eef2fb;
  color: #2a3b5d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.rt-who-lbl {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #8a92a8;
}
.rt-who-nm {
  font-size: 14px;
  font-weight: 700;
  color: #1c2238;
}
.rt-stars {
  display: flex;
  align-items: center;
  gap: 4px;
}
.rt-star {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #d9dde6;
  font-size: 22px;
  transition: color 0.15s;
}
.rt-star:hover:not(:disabled) {
  color: #f5b800;
}
.rt-star.filled {
  color: #f5b800;
}
.rt-star:disabled {
  cursor: default;
  opacity: 0.85;
}
.rt-stars-val {
  margin-left: 8px;
  font-size: 13px;
  color: #4a526a;
  font-weight: 700;
}
.rt-comment {
  width: 100%;
  border: 1.5px solid #e3e6ee;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  min-height: 70px;
  resize: vertical;
  outline: none;
  background: #fff;
  color: #1c2238;
}
.rt-comment:focus {
  border-color: #2a3b5d;
}
.rt-comment:disabled {
  background: #f8f9fc;
  color: #4a526a;
}
.rt-error {
  background: #fdecec;
  border: 1px solid #f6c0c0;
  color: #b43a3a;
  padding: 9px 12px;
  border-radius: 8px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-actions {
  padding: 14px 20px;
  border-top: 1px solid #eef0f5;
  display: flex;
  justify-content: flex-end;
}
.rt-btn {
  padding: 9px 22px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border: 1.5px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  transition: background 0.15s, opacity 0.15s;
}
.rt-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.rt-btn.primary {
  background: #2a3b5d;
  color: #fff;
  border-color: #2a3b5d;
}
.rt-btn.primary:hover:not(:disabled) {
  background: #1f2d4a;
}
</style>
